(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3456],{

/***/ 95473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ab_button_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42012);
/* harmony import */ var _ab_button_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ab_button_scss__WEBPACK_IMPORTED_MODULE_1__);


var Button = function(param) {
    var type = param.type, onClick = param.onClick, href = param.href, target = param.target;
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "ab-button".concat(type ? " ".concat(type) : ""),
            href: href,
            target: target,
            onClick: onClick
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "ab-button".concat(type ? " ".concat(type) : ""),
        onClick: onClick
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 63456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_ficha_carta_src; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var src = __webpack_require__(145);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../packages/ab-button/src/index.tsx
var ab_button_src = __webpack_require__(95473);
;// CONCATENATED MODULE: ../packages/ab-carta/src/MenuItem.tsx




var MenuItem = function(param) {
    var title = param.title, description = param.description, _options = param.options, options = _options === void 0 ? [] : _options;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "detail",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "h2",
                                children: title
                            }),
                            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                className: "title",
                                children: isOpen ? description : "".concat(description.substr(0, 75), "...")
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_button_src/* default */.Z, {
                        type: isOpen ? "menos" : "mas",
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "prices",
                children: options && (options === null || options === void 0 ? void 0 : options.length) && options.map(function(itm) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: isOpen ? "show" : undefined,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: itm.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: itm.price
                            })
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var src_MenuItem = (MenuItem);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ../packages/ab-context-modal/src/index.tsx + 5 modules
var ab_context_modal_src = __webpack_require__(49796);
;// CONCATENATED MODULE: ../packages/ab-carta/src/LinkItem.tsx





var LinkItem = function(param) {
    var title = param.title, description = param.description, link = param.link;
    var ref = (0,_sliced_to_array/* default */.Z)((0,ab_context_modal_src/* useModalContext */.vR)(), 2), stateModal = ref[0], dispatchMdoal = ref[1];
    var setShowModal = dispatchMdoal.setShowModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "item",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "detail",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "h2",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_button_src/* default */.Z, {
                            type: "mas",
                            href: link
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "web",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_button_src/* default */.Z, {
                            type: "mas",
                            onClick: function() {
                                return setShowModal(true, link);
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var src_LinkItem = (LinkItem);

;// CONCATENATED MODULE: ../packages/ab-carta/src/Categoria.tsx




var Categoria = function(param) {
    var title = param.title, _options = param.options, options = _options === void 0 ? [] : _options;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "detail",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                            element: "h2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_button_src/* default */.Z, {
                        type: isOpen ? "menos" : "mas",
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "options".concat(isOpen ? " show" : ""),
                children: options.map(function(itm) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                children: "• ".concat(itm.nombre)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title gold",
                                children: itm.precio
                            })
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var src_Categoria = (Categoria);

// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var ab_paragraph_text_src = __webpack_require__(2569);
;// CONCATENATED MODULE: ../packages/ab-carta/src/Menu.tsx





var Menu = function(param) {
    var title = param.title, _curso = param.curso, curso = _curso === void 0 ? [] : _curso, precio = param.precio, notas = param.notas, addicional = param.addicional, legal = param.legal;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "detail",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                            element: "h2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_button_src/* default */.Z, {
                        type: isOpen ? "menos" : "mas",
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "carta".concat(isOpen ? " show" : ""),
                children: [
                    curso === null || curso === void 0 ? void 0 : curso.map(function(itm) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                itm.nombre ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                    element: "span",
                                    className: "title border",
                                    children: itm.nombre
                                }) : null,
                                (ref = itm.platos) === null || ref === void 0 ? void 0 : ref.map(function(plate) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                        content: " - ".concat(plate.nombre),
                                        singleColumn: true,
                                        className: "flex-start"
                                    });
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "span",
                        className: "title",
                        children: precio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        element: "span",
                        className: "title",
                        children: addicional
                    }),
                    notas === null || notas === void 0 ? void 0 : notas.map(function(itm) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                            element: "span",
                            className: "title light",
                            children: itm.nota
                        });
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        className: "legal",
                        children: legal
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var src_Menu = (Menu);

// EXTERNAL MODULE: ../packages/ab-carta/src/menu-desplegable.scss
var menu_desplegable = __webpack_require__(64607);
;// CONCATENATED MODULE: ../packages/ab-carta/src/index.tsx







var MenuDesplegable = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items, carta = param.carta, menu = param.menu;
    // console.log("MenuDesplegable", items, carta, menu);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "menu-desplegable",
        children: [
            carta === null || carta === void 0 ? void 0 : carta.map(function(itm) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_Categoria, {
                    title: itm.nombreCategoria,
                    options: itm.categoria
                });
            }),
            menu === null || menu === void 0 ? void 0 : menu.map(function(itm) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_Menu, (0,_object_spread/* default */.Z)({
                    title: itm.nombre
                }, itm));
            }),
            items === null || items === void 0 ? void 0 : items.map(function(itm, index) {
                var ref;
                return itm.options ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src_MenuItem, {
                    title: itm.title,
                    description: itm.description,
                    options: itm.options
                }, "menu-item-".concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(src_LinkItem, {
                    title: itm.title,
                    description: itm.description,
                    link: itm === null || itm === void 0 ? void 0 : (ref = itm.archivo) === null || ref === void 0 ? void 0 : ref.mediaItemUrl
                }, "link-item-".concat(index));
            })
        ]
    });
};
/* harmony default export */ var ab_carta_src = (MenuDesplegable);

// EXTERNAL MODULE: ../packages/ab-ficha-carta/src/ficha-carta.scss
var ficha_carta = __webpack_require__(30890);
;// CONCATENATED MODULE: ../packages/ab-ficha-carta/src/index.tsx





var FichaCarta = function(param) {
    var _title = param.title, title = _title === void 0 ? "Un men\xfa a tu medida" : _title, _text = param.text, text = _text === void 0 ? [] : _text, content = param.content, _items = param.items, items = _items === void 0 ? [] : _items, h1 = param.h1, animated = param.animated, carta = param.carta, tipo = param.tipo, menu = param.menu;
    // console.log("FichaCarta -", carta, tipo, menu);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ficha-carta".concat(text.length > 0 || (content === null || content === void 0 ? void 0 : content.length) > 0 || tipo == "Santuario" ? " padding" : ""),
        children: [
            h1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                element: "h1",
                children: h1
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "h2",
                                animated: animated,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                text: text,
                                content: content,
                                singleColumn: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_carta_src, {
                        items: items,
                        carta: carta,
                        menu: menu
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_ficha_carta_src = (FichaCarta);


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    ;
                    if (itm.startsWith("<")) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: itm
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: viewMore ? function() {
                                return setViewMore(!viewMore);
                            } : null,
                            id: viewMore ? "less" : undefined,
                            className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                            children: itm
                        }, "paragraph-text-".concat(index));
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 42012:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 64607:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30890:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);